import { render, staticRenderFns } from "./FormPlantilla.vue?vue&type=template&id=28dd6d28&scoped=true"
import script from "./FormPlantilla.vue?vue&type=script&lang=js"
export * from "./FormPlantilla.vue?vue&type=script&lang=js"
import style0 from "./FormPlantilla.vue?vue&type=style&index=0&id=28dd6d28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28dd6d28",
  null
  
)

export default component.exports